/**
 * Created by neo on 20.01.21.
 */
import { v4 as UUID } from 'uuid';

export type MediaVideoTrack = {
  trackId: string;
  bitrate: number;
  codecs: string[];
  width: number;
  height: number;
  url: string;
};

/** @deprecated Use raw object instead */
export function createMediaVideoTrack(json?: Partial<MediaVideoTrack>): MediaVideoTrack {
  return {
    trackId: json?.trackId ?? UUID(),
    bitrate: json?.bitrate ?? 0,
    codecs: json?.codecs ?? [],
    width: json?.width ?? 0,
    height: json?.height ?? 0,
    url: json?.url ?? '',
  };
}
